import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerObjectDetailViewRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-object-detail-view',
	path: '/jira/assets/data-manager/object-classes/view/:objectClassId/object/:objectId',
	exact: true,
};
